import errors from 'Api/Helpers/apiErrors.json';

export const updateObject = (oldObject, newValues) => Object.assign({}, oldObject, newValues);
export const isMaliciousError = (error) => error?.body?.errorCode === errors.api.malicious.maliciousError;
